// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 774 ? "72a92d46" : chunkId) + "." + {"78":"4eca72aab996ed89","114":"372b123ded24f38c","774":"7e7e8f4dacbcc064"}[chunkId] + ".js";
};